var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProficient(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.801,
    height: 22.756,
    viewBox: "0 0 31.801 22.756",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7074",
    "data-name": "Group 7074",
    transform: "translate(-0.51 -9.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18957",
    "data-name": "Path 18957",
    d: "M22.226,39.266c-.127,0-.25,0-.377-.01A6.877,6.877,0,0,1,19.52,38.7l-8.49-3.69v3.817a4.672,4.672,0,0,0,1.008,2.98c3.866,4.712,16.583,4.9,20.136-.294a4.687,4.687,0,0,0,.768-2.647V34.95l-7.834,3.67A6.812,6.812,0,0,1,22.226,39.266Z",
    transform: "translate(-5.372 -12.869)",
    fill: "#21468a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18958",
    "data-name": "Path 18958",
    d: "M32.75,16.84a2.132,2.132,0,0,0-1.209-1.37L19.167,10.161a5.07,5.07,0,0,0-3.988,0L2.96,15.353a2.355,2.355,0,0,0-1.38,1.693,2.306,2.306,0,0,0,.259,1.62,1.474,1.474,0,0,1,.807-.45l11.46-2.2c.02,0,.034,0,.054-.01a4.511,4.511,0,0,1,3.445-1.258c2.143,0,3.822.988,3.822,2.251s-1.678,2.246-3.822,2.246a5.66,5.66,0,0,1-2.476-.524,1.505,1.505,0,0,1-.47.176L5.3,20.691l9.757,4.243a5.844,5.844,0,0,0,1.992.475,5.778,5.778,0,0,0,2.789-.543l11.744-5.5A2.126,2.126,0,0,0,32.75,16.84Z",
    transform: "translate(-0.522)",
    fill: "#21468a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18959",
    "data-name": "Path 18959",
    d: "M2.947,30.244,2.9,26.291l11.984-2.285a4.642,4.642,0,0,0,2.207.5c1.625,0,2.843-.67,2.843-1.272s-1.214-1.272-2.843-1.272c-1.541,0-2.711.6-2.838,1.17L2.311,25.4a.485.485,0,0,0-.4.489l.054,4.35a1.943,1.943,0,0,0,0,3.763v1.537a.489.489,0,1,0,.979,0V34.007a1.943,1.943,0,0,0,0-3.763Z",
    transform: "translate(0 -6.235)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProficient);
export default __webpack_public_path__ + "static/media/proficient.f8cb74f434c6f6bafeb5d3190402443e.svg";
export { ForwardRef as ReactComponent };